/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CompanyAvgFields {
    AVG_COMPANY_BASE = 'avgCompanyBase',
    AVG_COMPANY_ACTUAL_BONUS = 'avgCompanyActualBonus',
    AVG_COMPANY_TARGET_BONUS = 'avgCompanyTargetBonus',
    AVG_COMPANY_TARGET_TOTAL_CASH = 'avgCompanyTargetTotalCash',
    AVG_COMPANY_ACTUAL_TOTAL_CASH = 'avgCompanyActualTotalCash',
    AVG_COMPANY_TARGET_TOTAL_DIRECT = 'avgCompanyTargetTotalDirect',
    AVG_COMPANY_ACTUAL_TOTAL_DIRECT = 'avgCompanyActualTotalDirect',
    AVG_COMPANY_LTI_ACTUAL = 'avgCompanyLtiActual',
    AVG_COMPANY_LTI_ACTUAL_PCT = 'avgCompanyLtiActualPct',
    AVG_COMPANY_FIXED_COMP = 'avgCompanyFixedComp',
    AVG_COMPANY_TOTAL_ALLOWANCES = 'avgCompanyTotalAllowances',
    AVG_COMPANY_LTI_TARGET = 'avgCompanyLtiTarget',
    AVG_COMPANY_LTI_NEW_HIRE_ACTUAL = 'avgCompanyLtiNewHireActual',
    AVG_COMPANY_LTI_NEW_HIRE_TARGET = 'avgCompanyLtiNewHireTarget',
    AVG_COMPANY_SALES_INCENTIVE_ACTUAL = 'avgCompanySalesIncentiveActual',
    AVG_COMPANY_SALES_INCENTIVE_TARGET = 'avgCompanySalesIncentiveTarget',
    AVG_COMPANY_SALES_COMMISSION_PAID_ACTUAL = 'avgCompanySalesCommissionPaidActual',
    AVG_COMPANY_ANNUAL_BASE = 'avgCompanyAnnualBase',
    AVG_COMPANY_TRANSPORTATION_ALLOWANCE = 'avgCompanyTransportationAllowance',
    AVG_COMPANY_HOUSING_ALLOWANCE = 'avgCompanyHousingAllowance',
    AVG_COMPANY_MEAL_ALLOWANCE = 'avgCompanyMealAllowance',
    AVG_COMPANY_EDUCATION_ALLOWANCE = 'avgCompanyEducationAllowance',
    AVG_COMPANY_JOB_SKILL_ALLOWANCE = 'avgCompanyJobSkillAllowance',
    AVG_COMPANY_LANGUAGE_ALLOWANCE = 'avgCompanyLanguageAllowance',
    AVG_COMPANY_LEAVE_TRAVEL_ALLOWANCE = 'avgCompanyLeaveTravelAllowance',
    AVG_COMPANY_TELECOMMUNICATION_PHONE_ALLOWANCE = 'avgCompanyTelecommunicationPhoneAllowance',
    AVG_COMPANY_CAR_ALLOWANCE = 'avgCompanyCarAllowance',
    AVG_COMPANY_ACTUAL_BONUS_PCT = 'avgCompanyActualBonusPct',
    AVG_COMPANY_TARGET_BONUS_PCT = 'avgCompanyTargetBonusPct',
    AVG_COMPANY_LTI_TARGET_PCT = 'avgCompanyLtiTargetPct',
    AVG_COMPANY_SALES_INCENTIVE_PCT_ACTUAL = 'avgCompanySalesIncentivePctActual',
    AVG_COMPANY_SALES_INCENTIVE_PCT_TARGET = 'avgCompanySalesIncentivePctTarget',
    AVG_COMPANY_SALES_COMMISSION_TARGET_PCT = 'avgCompanySalesCommissionTargetPct',
}
